module.exports = __webpack_public_path__ + "static/questions-2d3bb674087c2652324d64b0ef4d342d.svg";